import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm, ComPhoto, GoodsPhoto } from "../../../js/ComponentManager";
import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:알림메세지 목록
 * 세부설명:
*/

export class AlertMsg extends Component {
    static displayName = AlertMsg.name;

    constructor(props) {
        super(props);
        this.state = {
            Allim_Mgt: [],
            btnDel_Show: false,
            Title: "",
            Content:""
        };
        //헤더의 휴지통을 클릭 하면 index의 prop함수를 호출, 그 함 수에서 handleLink_Click을 호출 하기 위한 ref값
        this.Trash = React.createRef();
        this.handleLink_Click = this.handleLink_Click.bind(this);
        this.handleDelete_Click = this.handleDelete_Click.bind(this);
        
    }
    //초기화
    componentDidMount() {
        this.CallAlertMsgData();
    }
    //알림 리스트 목록조회 
    async CallAlertMsgData() {
        try {
            let Data =await Big3Common.Get('api/MyPage/Notice/GetAllmMgtList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataList = JSON.parse(Data.dataTable);
                this.setState({ Allim_Mgt: DataList });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallAlertMsgData: ", e)
        }
        return false;
    }
    //클로디로 이동, 링크 이동처리
    handleLink_Click(event, list) {
        if (list === undefined) {
            this.props.RenderComponent("ClodMsg");
        }
        else {
            //읽음처리 및 링크 처리
            let conf_yn = list.conf_yn;
            let alim_cd = list.alim_cd;
            if (conf_yn !== "Y") {
                try {
                    Big3Common.Get(`api/MyPage/Notice/SetAllmMgtConfYn/${alim_cd}`);
                }
                catch (e) {
                    console.log("handleLink_Click", e);
                }   
            }
        }
        
        event.preventDefault();
    }
    //Index에서 호출, 삭제 이벤트 처리
    handleTrash_Click(isShow) {
        this.setState({ btnDel_Show: isShow });
    }
    async handleDelete_Click(alim_cd) {
        if (alim_cd === "all") {
            if (this.state.Allim_Mgt.length === 0) {
                this.setState({ Title: "삭제할 내용이 없습니다." });
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
            else {
                Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
            }
        }
        else {
            this.DeleteAllmgt(alim_cd);
        }
    }
    //알람 메세지 삭제
    async DeleteAllmgt(alim_cd) {
        try {
            let Data = await Big3Common.Get(`api/MyPage/Notice/RemoveAllmMgt/${alim_cd}`);
            this.setState({ Title: Data.message });
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
            this.CallAlertMsgData();
            return false;
        }
        catch (e) {
            console.log()
        }
    }
    // 01:주문요청, 02:주문요청,03:주문요청,04:재고문의(채팅),05:재고답변(채팅),06:주문문의(채팅),07:포장완료,08:거래완료,09:-,10:거래승인 요청
    // 11:거래승인 알림,12:클로디공지사항,13:도매 공지사항 알림,14:주문취소(소매->도매),15:주문취소(도매->소매),16:사입매칭,17:관리자요청알림
    Contentrender(list) {
        const Alim_Idx = list.alim_idx;
        let LinkUrl = `${list.linkpath}?${list.linkparams}&alim_idx=${Alim_Idx}`;
        if (list.linkparams === "") {
            LinkUrl = `${list.linkpath}?alim_idx=${Alim_Idx}`;
        }
        if (list.linkpath === "") {
            LinkUrl = "";
        }
        if (Alim_Idx === "01" || Alim_Idx === "04" || Alim_Idx === "14") {
            return (
                <Link to={LinkUrl}>
                    <div className="alert_img">
                        <GoodsPhoto
                            className="alert_img_in"
                            ImageSrc={list.alarm_img || ""}
                        />
                    </div>
                    <div className="alert_txt">
                        <div className="alert_title">{list.alim_idx_nm}</div>
                        <div className="product_name">상품명: {list.contentfld1}</div>
                        <div className="product_name">소매명: {list.contentfld2}</div>
                        <div className="product_name">가격: {Big3Common.Util.Money(list.contentfld3)}원</div>
                        <div className="alert_time">{list.wrtday}{list.conf_yn === "Y" ? "" : <div className="alert_new"></div>}</div>
                        {this.state.btnDel_Show === true ? <div className="alert_delete" onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleDelete_Click(list.alim_cd); }}></div> : ""}
                    </div>
                </Link>
            )
        }
        else if (Alim_Idx === "06" || Alim_Idx === "10" || Alim_Idx === "19") {
            return (
                <Link to={LinkUrl}>
                    <div className="alert_img">
                        <ComPhoto className="alert_img_in"
                            Photo={list.photo || ""} />
                    </div>
                    <div className="alert_txt">
                        <div className="alert_title">{list.alim_idx_nm}</div>
                        <div className="product_name">소매명: {list.contentfld1}</div>
                        <div className="product_name">{list.contentfld2}</div>
                        <div className="alert_time">{list.wrtday}{list.conf_yn === "Y" ? "" : <div className="alert_new"></div>}</div>
                        {this.state.btnDel_Show === true ? <div className="alert_delete" onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleDelete_Click(list.alim_cd) } }></div> : ""}
                    </div>
                </Link>
            )
        }
        else {
            //조건에 맞게 설정 안된 항목들
            return (
                <>
                    <div className="alert_img">
                        <div className="alert_img_in"></div>
                    </div>
                    <div className="alert_txt">
                        <div className="alert_title">{list.alim_idx_nm}</div>
                        <div className="product_name">제목: {list.contentfld1}</div>
                        <div className="product_name">내용: {list.contentfld2}</div>
                        <div className="alert_time">{list.wrtday}{list.conf_yn === "Y" ? "" : <div className="alert_new"></div>}</div>
                    </div>
                </>
                
            )
        }
        
    }
    //메세지 리스트 랜더링
    Messagerender() {
        let DataList = this.state.Allim_Mgt;
        return (
            <>
                {DataList.map(list =>
                    <div className="alert_content" key={list.alim_cd} onClick={(e) => this.handleLink_Click(e, list)}>
                        {this.Contentrender(list)}
                    </div> 
                 )}
            </>
        );
    }
    render() {
        let AlarmList = this.Messagerender();
        return (
            <div ref={this.Trash}>
                <div className="tap_box">
                    <div className="n_tap"><div className="alert_tap tap_on">알림</div></div>
                    <div className="n_tap"><div className="alert_tap" onClick={(e) => this.handleLink_Click(e)}>Clo:D공지</div></div>
                </div>
                <div className="container_box a_margin d_padding">
                    {this.state.btnDel_Show === true? 
                        <div className="delete_box">
                            <button type="button" className="delete_button" onClick={(e) => this.handleDelete_Click('all')} >전체삭제</button>
                        </div>
                     : ""
                    }
                    {AlarmList}
                </div>
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                />
                <Confirm
                    id="ConfirmBox"
                    title="삭제알림"
                    content="정말로 전체 메세지를 삭제하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);

                        this.DeleteAllmgt('all');
                    }}
                />
            </div>
        );
    }
}
